import styled from 'styled-components'
import { formatDate } from '../../../../../../../helpers/date'
import { formatFileSize } from '../../../../../../../helpers/files'
import {
    FileBox,
    FileDownload,
    FileDownloadIcon,
    FileIcon,
    FileInformationText,
    FileName,
} from '../../../../../whistleblower/new-case/styled/Files'
import { AiOutlineFilePdf } from 'react-icons/ai'
import { FaFileCsv } from 'react-icons/fa'
import { AiOutlineFileImage, AiOutlineFileWord } from 'react-icons/ai'
import config from '../../../../../../../config'
import axios from 'axios'
import { useTranslation, useLoadedOpenReport } from '../../../../../../../hooks'
import { ApiFile } from '../../../../../../../ts/api-types/File'

const FileContainer = styled.div`
    margin-top: 3.8rem;
    padding: 1.6rem 2.8rem;
`

const Flex = styled.div`
    display: flex;
    align-items: center;
    gap: 2rem;
    margin-inline-start: 0.5rem;
`

const NoFilesMessageText = styled.p`
    color: ${({ theme }) => theme.greyText};
    font-size: 1.2rem;
    font-weight: 300;
`

const SourceLabel = styled.label`
    font-size: 1.4rem;
    font-weight: 600;
    color: ${({ theme }) => theme.primary};
    display: block;
    margin-bottom: 0.8rem;
`

const SourceSection = styled.div`
    margin-bottom: 2rem;
`

interface FilesFrameProps {
    files: ApiFile[]
}

const FilesFrame: React.FC<FilesFrameProps> = ({ files }) => {
    const translation = useTranslation()

    const { openReport } = useLoadedOpenReport()

    const handleDownloadFile = async (file: any) => {
        const { apiUrl } = config

        const res: any = await axios.get(
            `${apiUrl}/v1/incidents/${openReport.id}/download/${file.id}`,
            {
                method: 'GET',
                responseType: 'blob',
                headers: { Accept: 'application/pdf' },
            }
        )

        const blob = new Blob([res.data], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = file.name
        link.click()
    }

    const filesBySource: Record<string, ApiFile[]> = {
        reporter: [],
        caseworker: [],
    }
    files.forEach((file) => {
        if (filesBySource[file.source]) {
            filesBySource[file.source].push(file)
        }
    })

    const sourceLabels: Record<string, string> = {
        reporter: translation.accessCaseFlow.fromWhistleblower,
        caseworker: translation.accessCaseFlow.fromCaseworker,
    }

    return (
        <FileContainer>
            {Object.entries(filesBySource).map(([source, sourceFiles]) => (
                <SourceSection key={source}>
                    <SourceLabel>{sourceLabels[source]}</SourceLabel>
                    {sourceFiles.length > 0 ? (
                        sourceFiles.map((file) => (
                            <FileBox
                                key={file.file_path}
                                onClick={() => handleDownloadFile(file)}
                            >
                                {file.extension === 'pdf' ? (
                                    <AiOutlineFilePdf size={30} />
                                ) : file.extension === 'csv' ? (
                                    <FaFileCsv size={30} />
                                ) : file.extension === 'jpg' ||
                                  file.extension === 'jpeg' ||
                                  file.extension === 'png' ? (
                                    <AiOutlineFileImage size={30} />
                                ) : file.extension === 'docx' ? (
                                    <AiOutlineFileWord size={30} />
                                ) : (
                                    <FileIcon />
                                )}
                                <div>
                                    <FileName>{file.name}</FileName>
                                    <Flex>
                                        <FileInformationText>
                                            {formatDate(file.created_at)}
                                        </FileInformationText>
                                        <FileInformationText>
                                            {formatFileSize(file.file_size)}
                                        </FileInformationText>
                                    </Flex>
                                </div>

                                <FileDownload className="file-download-icon">
                                    <FileDownloadIcon />
                                </FileDownload>
                            </FileBox>
                        ))
                    ) : (
                        <NoFilesMessageText>
                            {translation.caseworkerOpenReport.noFilesUploaded}
                        </NoFilesMessageText>
                    )}
                </SourceSection>
            ))}
        </FileContainer>
    )
}

export default FilesFrame
